import type { ReactElement } from "react";
import { Input } from "../../../shared/components/ui/input";
import { Label } from "../../../shared/components/ui/label";

interface TMDBSearchFormProps {
  query: string;
  year: string;
  loading: boolean;
  onQueryChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onSearch: () => void;
}

/**
 * TMDB Search Form Component
 */
export function TMDBSearchForm({
  query,
  year,
  loading,
  onQueryChange,
  onYearChange,
  onSearch,
}: Readonly<TMDBSearchFormProps>): ReactElement {
  return (
    <div className="bg-black/0">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
        <div className="md:col-span-2 space-y-2">
          <Label htmlFor="tmdb-query">Movie Title</Label>
          <Input
            id="tmdb-query"
            type="text"
            placeholder="Search for your film..."
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSearch();
              }
            }}
          />
        </div>
        <div className="md:col-span-2 space-y-2">
          <Label htmlFor="tmdb-year">Year</Label>
          <Input
            id="tmdb-year"
            className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            type="number"
            placeholder="2023"
            value={year}
            onChange={(e) => onYearChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSearch();
              }
            }}
          />
        </div>
        <div className="space-y-2">
          <Label>&nbsp;</Label>
          <button
            onClick={onSearch}
            disabled={!query.trim() || loading}
            className="w-full h-10 btn-admin-action disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>
      </div>
    </div>
  );
}
